<template>
<Expose class="black-content" :ratio="0.2" @expose="$emit('expose')">
    <div class="black-content-content">
        <div class="black-content-content-block">
            <img
                class="black-content-img"
                draggable="false"
                :src="bannerImg"
                :alt="title"
            />
            <div class="right">
                <div class="text">
                    <h3 class="title" :style="colorStyle">{{title}}</h3>
                    <p class="desc" :style="colorStyle">{{desc}}</p>
                    <p class="link" :style="colorStyle"><span>立即前往</span><Icon type="right" /></p>
                </div>
            </div>
            <div v-if="isUpload" class="mask">
                <img class="upload-img" src="https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211207-161736-e2d5.png"/>
                <UploadBtn @click="$emit('uploadClick', { button_nm: '上传本地图片' })" @upload="handleUpload" class="black-content-btn" btnClassName="upload-img-btn">上传本地图片</UploadBtn>
            </div>
            <div v-else class="mask">
                <a
                    :href="href"
                    target="_blank"
                    data-name="立即前往"
                    class="link-btn">立即前往<Icon type="right" /></a>
            </div>
        </div>
    </div>
    <div class="black-content-btns" v-if="btns && btns.length">
        <template v-for="(text, index) in btns">
            <a :href="href" target="_blank" :key="index" draggable="false">
                <div class="multi-btn" :data-name="text.name">
                    <img class="icon" :src="text.icon" :data-name="text.name"/>
                    <span :data-name="text.name">{{ text.name }}</span>
                </div>
            </a>
        </template>
    </div>
</Expose>

</template>
<script>
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Icon } from '@gaoding/gd-antd';
import UploadBtn from '../upload-btn';
import Expose from '../../../expose';
export default {
  name: 'black-content',
  components: {
    Icon,
    UploadBtn,
    Expose
  },
  props: {
    // 上传图片函数，应该返回一个value为图片url的promise
    uploadFunc: {
      type: Function,
      required: true
    },
    isUpload: Boolean,
    title: String,
    desc: String,
    bannerImg: String,
    href: String,
    color: {
      type: String,
      default: '#fff'
    },

    /**
     * btn.icon string 图标
     * btn.name string 按钮名
     */
    btns: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    colorStyle() {
      return "color: " + this.color;
    }

  },
  methods: {
    handleUpload(files) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.uploadFunc(files);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }

  }
};
</script>
<style scoped>
h2,
h3,
p {
  margin: 0;
  padding: 0;
}
img {
  user-select: none;
}
.black-content-btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.black-content {
  width: 408px;
  padding: 8px;
  box-sizing: border-box;
  background: #3e3e3f;
  color: #fff;
  box-shadow: 0px 12px 16px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
}
.black-content-title {
  margin: 0;
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  text-align: left;
  margin-bottom: 20px;
}
.black-content-content a {
  text-decoration: none;
}
.black-content-content-block {
  height: 200px;
  display: flex;
  border-radius: 4px;
}
.black-content-content-block .black-content-img {
  position: relative;
  width: 392px;
  height: 200px;
  border-radius: 4px;
}
.black-content-content-block .right {
  position: absolute;
  right: 32px;
}
.black-content-content-block .right .text {
  transition: margin-top 0.3s 0.2s;
  margin-top: 60px;
}
.black-content-content-block .right .text .title {
  font-weight: 500;
  font-size: 22px;
  line-height: 20px;
  color: #fff;
}
.black-content-content-block .right .text .desc {
  margin-top: 8px;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  opacity: 0.6;
}
.black-content-content-block .right .text .link {
  margin-top: 14px;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
}
.black-content-content-block .right .text .link > span {
  vertical-align: top;
}
.black-content-content-block .right .text .link > i {
  display: inline-block;
  margin-top: 2px;
  font-size: 12px;
}
.black-content-content-block .right .black-content-btn {
  margin-top: 20px;
  opacity: 0;
  transition: opacity 0.2s linear;
}
.black-content-content-block .mask {
  display: none;
  position: absolute;
  width: 392px;
  height: 200px;
  z-index: 2;
  content: '';
  box-shadow: 0px 10px 32px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s, background-color 0.2s;
  background: rgba(0, 0, 0, 0.8);
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  transition: all 0.4 ease;
}
.black-content-content-block .upload-img {
  margin: 0 auto;
  width: 68px;
  height: 51px;
}
.black-content-content-block .link-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  padding: 0 20px;
  width: 198px;
  height: 46px;
  line-height: 46px;
  border-radius: 4px;
  background-color: #2254f4;
  border-color: #2254f4;
  color: #ffffff;
  font-weight: bold;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;
}
.black-content-content-block .link-btn:hover {
  opacity: 0.9;
}
.black-content-content-block .link-btn > i {
  display: inline-block;
  margin-top: 5px;
  font-size: 14px;
}
.black-content-content:hover .black-content-content-block .mask {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
}
.black-content-btns {
  margin-top: 8px;
  display: flex;
}
.black-content-btns a:first-child {
  margin-right: 8px;
}
.black-content-btns a {
  text-decoration: none;
  flex: 1;
}
.black-content-btns /deep/ .multi-btn {
  padding: 0px 44px;
  height: 48px;
  line-height: 48px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.black-content-btns /deep/ .multi-btn > span {
  vertical-align: top;
}
.black-content-btns /deep/ .multi-btn .icon {
  margin: 13px 4px;
  width: 20px;
  height: 20px;
}
.black-content-btns /deep/ .multi-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}
.black-content-footer {
  margin: 0;
  font-size: 14px;
  line-height: 14px;
  text-align: left;
  margin-top: 20px;
  color: #636c78;
}
.black-content-footer a {
  color: #2254f4;
  text-decoration: none;
}
.black-content-footer a:hover {
  font-weight: bold;
}

</style>
